import {createSlice } from '@reduxjs/toolkit'

const AdvanceReprotsSlice = createSlice({
    name: "AdvanceReprotsSlice",
    initialState: {
        AdvanceReportED: {}
    },
    reducers: {
        AddOneAdvanceReprot(state, actions){
            state.AdvanceReportED = actions.payload[0]
        },
        addAdeddArticle(state, actions){            
            state.AdvanceReportED.Articles = actions.payload
        },
        changeBalanceBeginningMonthCash(state, actions){
            state.AdvanceReportED.BalanceBeginningMonthCash = actions.payload
        },
        changeBalanceBeginningMonthNonCash(state, actions){
            state.AdvanceReportED.BalanceBeginningMonthNonCash = actions.payload
        },
        changeBlockEdit(state, actions){
            state.AdvanceReportED.BlockEdit = actions.payload
        },
        AddArrayAdvanceReport(state, actions){
            state.AdvanceReportED = actions.payload
        },
        changeInfAdvanceReport(state, actions){
            state.AdvanceReportED.map((el) => {
                if(el.id === actions.payload.id)
                {
                    switch(actions.payload.Type){
                        case('AdminSumCash'):{
                            el.AdminSumCash = actions.payload.Value
                            break
                        }
                        case('AdminSumNonCash'):{
                            el.AdminSumNonCash = actions.payload.Value
                            break
                        }
                        case('AdminComment'):{
                            el.AdminComment = actions.payload.Value
                            break
                        }
                        case('RevenueFrontpad'):{
                            el.RevenueFrontpad = actions.payload.Value
                            break
                        }
                        case('NumDelivery'):{
                            el.NumDelivery = actions.payload.Value
                            break
                        }
                        case('PercentRemains'):{
                            el.PercentRemains = actions.payload.Value
                            break
                        }
                        default:{
                            break
                        }
                    }
                }
                return(el)
            })
           }
    }
})

export default AdvanceReprotsSlice.reducer
export const { 
    changeBlockEdit, 
    changeBalanceBeginningMonthNonCash, 
    AddOneAdvanceReprot, 
    changeBalanceBeginningMonthCash, 
    addAdeddArticle,
    AddArrayAdvanceReport,
    changeInfAdvanceReport
} = AdvanceReprotsSlice.actions